/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import dynamicComponent from '../dynamicComponent';

const Dashboard = dynamicComponent(() => import(/* webpackChunkName: "DashboardSection" */ './dashboard'));

const HelpCenter = dynamicComponent(() => import(/* webpackChunkName: "HelpCenterSection" */ './helpCenter'));

const Admin = dynamicComponent(() => import(/* webpackChunkName: "AdminSection" */ './admin'));

const AppBuilder = dynamicComponent(() => import(/* webpackChunkName: "AppBuilderSection" */ './appBuilder'));

const Contents = dynamicComponent(() => import(/* webpackChunkName: "ContentsSection" */ './contents'));

const Monetization = dynamicComponent(() => import(/* webpackChunkName: "MonetizationSection" */ './monetization'));

const PlaylistManager = dynamicComponent(() => import(/* webpackChunkName: "PlaylistManagerSection" */ './playlistManager'));

const AddApps = dynamicComponent(() => import(/* webpackChunkName: "AddAppsSection" */ './addApps'));

const Login = dynamicComponent(() => import(/* webpackChunkName: "LoginPage" */ './login'));

const Addons = dynamicComponent(() => import(/* webpackChunkName: "AddonsPage" */ './addons'));

const ManageApps = dynamicComponent(() => import(/* webpackChunkName: "CreateAppPage" */ './manageApps'));

const Cms = dynamicComponent(() => import(/* webpackChunkName: "CmsPage" */ './cms'));

export {
    Dashboard,
    HelpCenter,
    Admin,
    AppBuilder,
    Contents,
    Monetization,
    PlaylistManager,
    Login,
    Addons,
    AddApps,
    ManageApps,
    Cms,
};